import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMousePointer, FiFileText, FiCreditCard, FiShield } = FiIcons;

const ProcessSection = () => {
  const steps = [
    {
      icon: FiMousePointer,
      title: "Apply",
      description: "Quick online form",
      time: "10 min"
    },
    {
      icon: FiFileText,
      title: "Quote",
      description: "Instant pricing",
      time: "Instant"
    },
    {
      icon: FiCreditCard,
      title: "Pay",
      description: "Secure checkout",
      time: "1 min"
    },
    {
      icon: FiShield,
      title: "Protected",
      description: "Coverage starts",
      time: "Same day"
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Simple Process
          </h2>
          <p className="text-xl text-gray-600">
            Get covered in 4 easy steps
          </p>
        </motion.div>

        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="relative text-center"
            >
              <div className="bg-blue-50 rounded-3xl p-8 hover:bg-blue-100 transition-colors duration-300">
                <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <SafeIcon icon={step.icon} className="text-white text-2xl" />
                </div>
                <div className="bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-full inline-block mb-4">
                  {step.time}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <div className="w-8 h-0.5 bg-blue-200"></div>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-3xl p-12 text-center"
        >
          <h3 className="text-3xl font-bold mb-4">Ready to get started?</h3>
          <p className="text-xl text-blue-100 mb-8">
            Join 50,000+ businesses already protected
          </p>
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-gray-50 transition-colors duration-300 inline-block"
          >
            Start Application
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;